import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./styles.scss";

import headerImg from "../../Assets/Images/kgImage.png"

import FooterColorLine from "Components/FooterColorLine";

import { useDispatch } from "react-redux";
import { policyRequest } from "../../Redux/Slices/authSlice";

const AboutUsPage = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  console.log(location.pathname)

  const [policyData, setPolicyData] = useState(null);
  useEffect(() => {
    dispatch(
      policyRequest({
        data: {
          id: location.pathname === '/terms-of-use' ? 3 : location.pathname === '/privacy-policy' ? 2 : 1
        },
        callBack: (data) => {
          console.log(data.data)
          setPolicyData(data.data)
        },
      })
    );
  }, []);

  if (!policyData) return <div className="loading">Loading...</div>;

  return (
    <div className="containerAboutUsPage">
  <header>
    <h1>KG</h1>
  </header>

  <div className="headerColorLine">
    <FooterColorLine />
  </div>

  <div className="banner-image">
    <img src={headerImg} alt="Banner" />
    <h1 className="banner-text">{policyData?.title || "-"}</h1>
  </div>

  <main className="mainContent">
    <div className="contentContainer">
      <h2 style={{ fontSize: "28px", fontWeight: "600" }}>
        {policyData?.title || "-"}
      </h2>
      {policyData?.description ? (
        <div dangerouslySetInnerHTML={{ __html: policyData.description }} />
      ) : (
        <p>No Data Found</p>
      )}
    </div>
  </main>

  <div className="footerColorLine">
    <FooterColorLine />
  </div>
</div>

  );
};

export default AboutUsPage;
